module.exports = __webpack_public_path__ + "static/media/board.a39f05c9.jpg";